import dhtmlXCombo from './dhtmlXCombo';
import {dhtmlXComboExtend} from "./commonFun";
import {dhx4} from "../../global/dhx4OrDhx";

dhtmlXCombo.prototype._showList = function (a) {
    if (this._getListVisibleCount() == 0) {
        if (a && this._isListVisible()) {
            this._hideList();
        }
        return;
    }
    if (this._isListVisible()) {
        this._checkListHeight();
        return;
    }
    this.list.style.zIndex = dhx4.zim.reserve(this.conf.list_zi_id);
    if (this.hdr != null && this.conf.template.header == true) {
        this.hdr.style.zIndex = Number(this.list.style.zIndex) + 1;
    }
    this.list.style.visibility = "hidden";
    this.list.style.display = "";
    if (this.hdr != null && this.conf.template.header == true) {
        this.hdr.style.visibility = this.list.style.visibility;
        this.hdr.style.display = this.list.style.display;
    }
    var c = (this.hdr != null && this.conf.template.header == true ? this.hdr.offsetHeight : 0);
    this.list.style.width = Math.max(this.conf.opts_width || this.conf.col_w || 0, this.conf.combo_width) + "px";
    this.list.style.top = dhx4.absTop(this.base) + c + this.base.offsetHeight - 1 + "px";
    this.list.style.left = dhx4.absLeft(this.base) + "px";
    if (this.hdr != null && this.conf.template.header == true) {
        this.hdr.style.width = this.list.style.width;
        this.hdr.style.left = this.list.style.left;
        this.hdr.style.top = parseInt(this.list.style.top) - c + "px";
    }
    this._checkListHeight();
    this.list.style.visibility = "visible";
    if (this.hdr != null && this.conf.template.header == true) {
        this.hdr.style.visibility = "visible";
    }
    this.callEvent("onOpen", []);
};
dhtmlXCombo.prototype._hideList = function () {
    if (!this._isListVisible()) {
        return;
    }
    dhx4.zim.clear(this.conf.list_zi_id);
    this.list.style.display = "none";
    if (this.hdr != null && this.conf.template.header == true) {
        this.hdr.style.display = "none";
    }
    this.conf.clear_click = false;
    this.callEvent("onClose", []);
};
dhtmlXCombo.prototype._isListVisible = function () {
    return (this.list.style.display == "");
};
dhtmlXCombo.prototype._getListVisibleCount = function () {
    var a = 0;
    for (var c = 0; c < this.list.childNodes.length; c++) {
        a += (this.list.childNodes[c].style.display == "" ? 1 : 0);
    }
    return a;
};
dhtmlXCombo.prototype._checkListHeight = function () {
    if (!this._isListVisible()) {
        return;
    }
    if (this.conf.item_h == null) {
        var r = this.list.firstChild;
        while (r != null) {
            if (r.style.display == "") {
                this.conf.item_h = r.offsetHeight + (this.hdr != null ? -1 : 0);
                r = null;
            } else {
                r = r.nextSibling;
            }
        }
        r = null;
    }
    var u = dhx4.screenDim();
    var m = dhx4.absTop(this.base);
    var c = this.base.offsetHeight;
    var a = (this.hdr != null && this.conf.template.header == true ? this.hdr.offsetHeight : 0);
    var e = Math.max(0, Math.floor((m + a - u.top) / this.conf.item_h));
    var o = Math.max(0, Math.floor((u.bottom - (m + c + a)) / this.conf.item_h));
    var v = this._getListVisibleCount();
    if (o < Math.min(this.conf.opts_count_min, v) && e > o) {
        o = null;
    }
    var n = Math.min((o == null ? e : o), this.conf.opts_count, v);
    var g = (n < v ? (n * this.conf.item_h) + "px" : "");
    var l = this.conf.sp[this.conf.skin][this.hdr != null && this.conf.template.header == true ? "hdr_ofs" : "list_ofs"];
    this.list.style.height = g;
    this.list.style.top = (o == null ? m - this.list.offsetHeight + l : m + c + a - l) + "px";
    if (this.hdr != null && this.conf.template.header == true) {
        this.hdr.style.top = (o == null ? m - a - this.list.offsetHeight + l : m + c - l) + "px";
    }
};
dhtmlXCombo.prototype._scrollToItem = function (h) {
    var g = this.t[h].item.offsetTop;
    var e = g + this.t[h].item.offsetHeight;
    var c = this.list.scrollTop;
    var a = c + this.list.clientHeight;
    if (g < c) {
        this.list.scrollTop = g + (this.hdr != null && this.conf.template.header == true ? 1 : 0);
    } else {
        if (e > a) {
            this.list.scrollTop = e - this.list.clientHeight + (this.hdr != null && this.conf.template.header == true ? -this.conf.sp[this.conf.skin].scr_ofs : 0);
        }
    }
};
dhtmlXCombo.prototype._setSelected = function (g, e, c, a) {
    this.conf.temp_selected = null;
    if (c) {
        this._updateTopImage(g);
    }
    if (g != null && this.conf.last_hover == g) {
        if (e) {
            this._scrollToItem(g);
        }
        return;
    }
    if (this.conf.last_hover != null) {
        this.t[this.conf.last_hover].obj.setSelected(this.t[this.conf.last_hover].item, false);
        this.conf.last_hover = null;
        if (g == null) {
            this.callEvent("onSelectionChange", []);
        }
    }
    if (g != null) {
        this.t[g].obj.setSelected(this.t[g].item, true);
        this.conf.last_hover = g;
        if (a != true) {
            this.conf.temp_selected = g;
            this.callEvent("onSelectionChange", []);
        }
        if (this.conf.s_mode == "select" && this.t[g].item == this.t[g].item.parentNode.lastChild) {
            this._subloadRequest();
        }
        if (e) {
            this._scrollToItem(g);
        }
    }
};
dhtmlXCombo.prototype._subloadRequest = function () {
    if (this.conf.f_url != null && this.conf.f_dyn == true && this.conf.f_dyn_end == false) {
        var e = "mask=" + encodeURIComponent(this.conf.f_mask) + "&pos=" + this.list.childNodes.length;
        var a = this;
        var c = function (h) {
            if (a.conf.f_cache) {
                a.conf.f_cache_data[a.conf.f_mask].data.push(h.xmlDoc.responseXML);
            }
            var g = a.list.childNodes.length;
            a.conf.f_loading = true;
            a.load(h.xmlDoc.responseXML);
            a.conf.f_loading = false;
            if (g == a.list.childNodes.length) {
                a.conf.f_dyn_end = true;
                if (a.conf.f_cache) {
                    a.conf.f_cache_data[a.conf.f_mask].dyn_end = true;
                }
            }
            c = a = null;
        };
        if (dhx4.ajax.method == "post") {
            dhx4.ajax.post(this.conf.f_url, e, c);
        } else {
            if (dhx4.ajax.method == "get") {
                dhx4.ajax.get(this.conf.f_url + (String(this.conf.f_url).indexOf("?") >= 0 ? "&" : "?") + e, c);
            }
        }
    }
};
dhtmlXCombo.prototype.addOption = function (l, m, c, a, g) {
    var e = null;
    var n = null;
    if (!(l instanceof Array)) {
        n = this._renderOption({value: l, text: m, css: c, img: a});
        if (e == null && dhx4.s2b(g) == true) {
            e = n;
        }
    } else {
        for (var h = 0; h < l.length; h++) {
            if (typeof (l[h]) == "undefined") {
                continue;
            }
            if (l[h] instanceof Array) {
                n = this._renderOption({value: l[h][0], text: l[h][1], css: l[h][2], img: l[h][3]});
                if (e == null && dhx4.s2b(l[h][4]) == true) {
                    e = n;
                }
            } else {
                n = this._renderOption(l[h]);
                if (e == null && dhx4.s2b(l[h].selected) == true) {
                    e = n;
                }
            }
        }
    }
    if (e != null) {
        this._setSelected(e, this._isListVisible(), true);
        this._confirmSelect("onInit");
    }
};
dhtmlXCombo.prototype.updateOption = function (a, e, c, g) {
    var h = this._getOptionId(a);
    if (h == null) {
        return;
    }
    this.t[h].obj.update(this.t[h].item, {value: e, text: c, css: g});
    if (this.conf.last_selected == h) {
        this.conf.last_text = this.base.firstChild.value = this.t[h].obj.getText(this.t[h].item, true);
        this.conf.f_server_last = this.base.firstChild.value.toLowerCase();
    }
};
dhtmlXCombo.prototype.deleteOption = function (g) {
    for (var c in this.t) {
        var e = this.t[c].obj.getValue(this.t[c].item);
        if (e == g) {
            this._removeOption(c);
        }
    }
    if (this._isListVisible()) {
        this._showList(true);
    }
};
dhtmlXCombo.prototype.clearAll = function (c) {
    c = (typeof (c) == "undefined" ? true : dhx4.s2b(c));
    for (var e in this.t) {
        this._removeOption(e);
    }
    if (this.conf.tm_hover) {
        window.clearTimeout(this.conf.tm_hover);
    }
    this.conf.last_hover = null;
    this.conf.last_selected = null;
    this.list.scrollTop = 0;
    if (c == true) {
        this._hideList();
    }
};
dhtmlXCombo.prototype._renderOption = function (g) {
    var h = dhx4.newId();
    var e = document.createElement("DIV");
    e._optId = h;
    e._tpl = this.conf.template;
    if (typeof (g.img) == "undefined" && typeof (g.img_src) != "undefined") {
        g.img = g.img_src;
        delete g.img_src;
    }
    if (typeof (g.img_dis) == "undefined" && typeof (g.img_src_dis) != "undefined") {
        g.img_dis = g.img_src_dis;
        delete g.img_src_dis;
    }
    g.img_path = this.conf.img_path;
    g.img_def = this.conf.img_def;
    g.img_def_dis = this.conf.img_def_dis;
    this.list.appendChild(e);
    var c = (this._isListVisible() && dhx4.isFF == true);
    if (c == true) {
        this.list.scrollTop -= 1;
    }
    if (this.hdr != null) {
        g.multicol = true;
    }
    this.t[e._optId] = {obj: this.modes[this.conf.opts_type].render(e, g), item: e, conf: {type: this.conf.opts_type}};
    e = null;
    if (c == true) {
        this.list.scrollTop += 1;
    }
    return h;
};
dhtmlXCombo.prototype._removeOption = function (a) {
    this.t[a].obj.destruct(this.t[a].item);
    this.t[a].obj = null;
    this.t[a].item.parentNode.removeChild(this.t[a].item);
    this.t[a].item = null;
    this.t[a].conf = null;
    this.t[a] = null;
    delete this.t[a];
    if (this.conf.last_hover == a) {
        this.conf.last_hover = null;
    }
    if (this.conf.last_selected == a) {
        this.conf.last_selected = null;
        this._confirmSelect("onDelete");
    }
};
dhtmlXCombo.prototype._confirmSelect = function (e, a) {
    var c = false;
    if (typeof (a) == "undefined") {
        a = true;
    }
    if (this.conf.f_server_tm) {
        window.clearTimeout(this.conf.f_server_tm)
    }
    if (this.conf.last_hover != null) {
        c = c || (this.conf.last_value != this._getOptionValue(this.conf.last_hover));
        this.conf.last_match = this.conf.last_selected = this.conf.last_hover;
        this.conf.last_value = this._getOptionValue(this.conf.last_selected);
        this.conf.last_text = this.base.firstChild.value = this.t[this.conf.last_selected].obj.getText(this.t[this.conf.last_selected].item, true);
        this.conf.f_server_last = this.base.firstChild.value.toLowerCase();
        this.base.childNodes[1].value = this.conf.last_value;
        this.base.childNodes[2].value = "false";
    } else {
        if (this.conf.allow_free_text || (this.base.firstChild.value == "" && this.conf.allow_empty_value)) {
            c = c || (this.conf.last_text != this.base.firstChild.value);
            this.conf.last_match = this.conf.last_value = this.conf.last_selected = null;
            this.conf.last_text = this.base.firstChild.value;
            this.conf.f_server_last = this.base.firstChild.value.toLowerCase();
            this.base.childNodes[1].value = this.conf.last_text;
            this.base.childNodes[2].value = "true";
        } else {
            this._cancelSelect(true);
            this._updateTopImage(this.conf.last_selected);
            return;
        }
    }
    if (this.conf.f_ac && this.conf.f_mode == "start") {
        this.conf.f_ac_text = "";
        if (e != "blur") {
            this._selectRange(this.base.firstChild.value.length, this.base.firstChild.value.length);
        }
    }
    if (a) {
        this._hideList();
    }
    if (c == true && e != "onInit" && e != "onDelete") {
        this.callEvent("onSelectionChange", []);
        this.callEvent("onChange", [this.conf.last_value, this.conf.last_text]);
    }
};
dhtmlXCombo.prototype._cancelSelect = function (a) {
    this._hideList();
    if (a == true && this.conf.allow_free_text == false && this.conf.free_text_empty == true) {
        this.conf.f_server_last = this.conf.last_match = this.conf.last_value = this.conf.last_selected = null;
        this.base.childNodes[1].value = this.conf.last_text = this.base.firstChild.value = "";
        this.base.childNodes[2].value = "false";
    } else {
        this.base.firstChild.value = this.conf.last_text;
    }
    if (this.conf.f_mode != false) {
        this._filterOpts(true);
    }
};
dhtmlXCombo.prototype._getOption = function (m, g) {
    if (!this.t[m]) {
        return null;
    }
    if (typeof (g) == "undefined") {
        g = -1;
    }
    if (g < 0) {
        for (var l = 0; l < this.list.childNodes.length; l++) {
            if (g < 0 && this.list.childNodes[l]._optId == m) {
                g = l;
            }
        }
    }
    var h = {
        value: this.t[m].obj.getValue(this.t[m].item),
        text: this.t[m].obj.getText(this.t[m].item),
        text_input: this.t[m].obj.getText(this.t[m].item, true),
        text_option: this.t[m].obj.getText(this.t[m].item, null, true),
        css: this.t[m].obj.getCss(this.t[m].item),
        selected: (m == this.conf.last_selected),
        index: g
    };
    if (typeof (this.t[m].obj.getExtraData) == "function") {
        var e = this.t[m].obj.getExtraData(this.t[m].item);
        for (var c in e) {
            if (typeof (h[c]) == "undefined") {
                h[c] = e[c];
            }
        }
    }
    return h;
};
dhtmlXCombo.prototype._getOptionProp = function (g, e, c) {
    if (g != null) {
        var a = this._getOption(g);
        if (a != null) {
            return a[e];
        }
    }
    return c;
};
dhtmlXCombo.prototype._getOptionId = function (c) {
    var g = null;
    for (var a = 0; a < this.list.childNodes.length; a++) {
        if (g == null) {
            var e = this.list.childNodes[a]._optId;
            if (c == this.t[e].obj.getValue(this.t[e].item)) {
                g = e;
            }
        }
    }
    return g;
};
dhtmlXCombo.prototype._getOptionValue = function (a) {
    return this._getOptionProp(a, "value", null);
};
dhtmlXCombo.prototype.setSize = function (a) {
    this.conf.combo_width = parseInt(a) - (dhx4.isFF || dhx4.isIE || dhx4.isChrome || dhx4.isOpera ? 2 : 0);
    this.base.style.width = Math.max(0, this.conf.combo_width) + "px";
    this._adjustBase();
};
dhtmlXCombo.prototype._adjustBase = function () {
    this.base.firstChild.style.width = Math.max(0, (this.conf.combo_width - (this.conf.i_ofs + 1) - (this.conf.combo_image ? this.conf.i_ofs : 0))) + "px";
    this.base.firstChild.style.marginLeft = (this.conf.combo_image ? this.conf.i_ofs + "px" : "0px");
};
dhtmlXCombo.prototype.setOptionWidth = function (a) {
    this.conf.opts_width = (parseInt(a) || null);
};
dhtmlXCombo.prototype.setOptionIndex = function (e, a) {
    if (isNaN(a) || a < 0) {
        return;
    }
    var g = this.getOption(e);
    if (g == null) {
        return;
    }
    if (a == g.index) {
        return;
    }
    var c = this.list.childNodes[g.index];
    c.parentNode.removeChild(c);
    if (this.list.childNodes[a] != null) {
        this.list.insertBefore(c, this.list.childNodes[a]);
    } else {
        this.list.appendChild(c);
    }
    c = null;
};
dhtmlXCombo.prototype.getOptionsCount = function () {
    return this.list.childNodes.length;
};
dhtmlXCombo.prototype._mcMakeTemplate = function (o) {
    var l = "";
    var g = "";
    this.conf.col_w = 0;
    var a = null;
    for (var m = 0; m < o.length; m++) {
        a = Number(parseInt(o[m].width) || 50);
        var e = (o[m].css || "");
        var n = (m == 0 && dhx4.isIE6 == true ? "_first" : "");
        g += "<div class='dhxcombo_cell" + n + " " + e + "' style='width:" + a + "px;'><div class='dhxcombo_cell_text'>" + (o[m].option || "&nbsp;") + "</div></div>";
        l += "<div class='dhxcombo_hdrcell" + n + " " + e + "' style='width:" + a + "px;'><div class='dhxcombo_hdrcell_text'>" + (o[m].header || "&nbsp;") + "</div></div>";
        this.conf.col_w += a + 1;
    }
    a = 500;
    var c = document.createElement("DIV");
    c.style.position = "absolute";
    c.style.top = "10px";
    c.style.left = -a * 2 + "px";
    c.style.width = a + "px";
    c.style.height = "50px";
    c.style.overflowY = "scroll";
    c.innerHTML = "<div>&nbsp;</div>";
    document.body.appendChild(c);
    this.conf.col_w += a - c.firstChild.offsetWidth + 10;
    c.parentNode.removeChild(c);
    c = null;
    this.conf.template.option = g;
    this._mcAttachHeader(l);
    this.list.className += " dhxcombolist_multicolumn";
};

dhtmlXCombo.prototype._mcAttachHeader = function (a) {
    if (this.hdr == null) {
        this.hdr = document.createElement("DIV");
        this.hdr.className = "dhxcombolist_" + this.conf.skin + " dhxcombolist_hdr";
        this.hdr.style.display = "none";
        this.list.parentNode.insertBefore(this.hdr, this.list);
        if (typeof (window.addEventListener) == "function") {
            this.hdr.addEventListener("mousedown", this._doOnListMouseDown, false);
        } else {
            this.hdr.attachEvent("onmousedown", this._doOnListMouseDown);
        }
        if (this.conf.opts_type == "checkbox" && this.conf.combo_image == true) {
            this.conf.combo_image = false;
            if (this.base.lastChild.className.match(/dhxcombo_top_image/) != null) {
                this.base.removeChild(this.base.lastChild);
            }
            this._adjustBase();
        }
    }
    this.hdr.innerHTML = "<div class='dhxcombo_hdrtext'>" + a + "</div>";
};
dhtmlXCombo.prototype._mcDetachHeader = function () {
    if (this.hdr != null) {
        if (typeof (window.addEventListener) == "function") {
            this.hdr.removeEventListener("mousedown", this._doOnListMouseDown, false);
        } else {
            this.hdr.detachEvent("onmousedown", this._doOnListMouseDown);
        }
        this.hdr.parentNode.removeChild(this.hdr);
        this.hdr = null;
    }
    this.conf.col_w = null;
    this.conf.item_h = null;
};
dhtmlXCombo.prototype.modes = {};
dhtmlXCombo.prototype.doWithItem = function (a, m, h, e) {
    var l = (a >= 0 && a < this.list.childNodes.length ? this.list.childNodes[a]._optId : null);
    if (l == null) {
        return null;
    }
    if (typeof (this.t[l].obj[m]) != "function") {
        return null;
    }
    var g = [this.t[l].item];
    for (var c = 2; c < arguments.length; c++) {
        g.push(arguments[c]);
    }
    return this.t[l].obj[m].apply(this.t[l].obj, g);
};


dhtmlXCombo.prototype.modes.option = {
    image: false,
    html: false,
    option_css: "dhxcombo_option_text",
    render: function (a, c) {
        a._conf = {value: c.value, css: ""};
        a.className = "dhxcombo_option";
        a.innerHTML = "<div class='" + this.option_css + "'>&nbsp;</div>";
        if (c.css != null) {
            a.lastChild.style.cssText = c.css;
            a._conf.css = c.css;
        }
        this.setText(a, c.text);
        return this;
    },
    destruct: function (a) {
        a._conf = null;
    },
    update: function (a, c) {
        a._conf.value = c.value;
        a._conf.css = c.css;
        a.lastChild.style.cssText = c.css;
        this.setText(a, c.text);
    },
    setText: function (e, g, c) {
        e._conf.text = g;
        var a = (typeof (g) == "object" ? dhx4.template(e._tpl.option, this.replaceHtml(e._conf.text, c), true) : dhx4.trim(this.replaceHtml(e._conf.text, c) || ""));
        e.lastChild.innerHTML = (a.length == 0 ? "&nbsp;" : a);
    },
    getText: function (e, a, c) {
        if (dhx4.s2b(a) && typeof (e._conf.text) == "object") {
            return dhx4.template(e._tpl.input, e._conf.text, true);
        }
        if (dhx4.s2b(c) && typeof (e._conf.text) == "object") {
            return dhx4.template(e._tpl.option, e._conf.text, true);
        }
        return e._conf.text;
    },
    getValue: function (a) {
        return a._conf.value;
    },
    getCss: function (a) {
        return a._conf.css;
    },
    setSelected: function (a, c) {
        a.className = "dhxcombo_option" + (c ? " dhxcombo_option_selected" : "");
    },
    isSelected: function (a) {
        return String(a.className).indexOf("dhxcombo_option_selected") >= 0;
    },
    getExtraData: function (a) {
        return {type: "option"};
    },
    replaceHtml: function (h, g) {
        if (this.html == true) {
            return h;
        }
        if (typeof (g) == "undefined" || g == null) {
            g = {};
        }

        var e = {};
        if (typeof (h) == "object") {
            for (var c in h) {
                e[c] = (g[c] == true ? h[c] : this.replaceHtml(h[c]));
            }
        } else {
            e = (h || "").replace(/[\<\>\&\s]/g, function (a) {
                switch (a) {
                    case"<":
                        return "&lt;";
                    case">":
                        return "&gt;";
                    case"&":
                        return "&amp;";
                    case" ":
                        return "&nbsp;";
                }
                return a;
            });
        }
        return e;
    }
};
dhtmlXCombo.prototype.modes.checkbox = {
    image: true,
    html: false,
    image_css: "dhxcombo_checkbox dhxcombo_chbx_#state#",
    option_css: "dhxcombo_option_text dhxcombo_option_text_chbx",
    render: function (c, e) {
        if (this.image_css_regexp == null) {
            this.image_css_regexp = new RegExp(this.image_css.replace("#state#", "\\d*"));
        }
        c._conf = {value: e.value, css: "", checked: dhx4.s2b(e.checked)};
        c.className = "dhxcombo_option";
        var a = {};
        if (e.multicol == true) {
            e.text.checkbox = "<div class='" + String(this.image_css).replace("#state#", (c._conf.checked ? "1" : "0")) + "'></div>&nbsp;";
            a.checkbox = true;
            c.innerHTML = "<div class='" + dhtmlXCombo.prototype.modes.option.option_css + "'></div>";
        } else {
            c.innerHTML = "<div class='" + String(this.image_css).replace("#state#", (c._conf.checked ? "1" : "0")) + "'></div><div class='" + this.option_css + "'>&nbsp;</div>";
        }
        if (e.css != null) {
            c.lastChild.style.cssText += e.css;
            c._conf.css = e.css;
        }
        this.setText(c, e.text, a);
        return this;
    },
    setChecked: function (c, e) {
        c._conf.checked = dhx4.s2b(e);
        var a = String(this.image_css).replace("#state#", (c._conf.checked ? "1" : "0"));
        this._changeChbxCss(c.childNodes, a);
    },
    _changeChbxCss: function (a, c) {
        for (var e = 0; e < a.length; e++) {
            if (a[e].tagName != null && a[e].className != null && a[e].className.match(this.image_css_regexp) != null) {
                a[e].className = c;
            } else {
                if (a[e].childNodes.length > 0) {
                    this._changeChbxCss(a[e].childNodes, c);
                }
            }
        }
    },
    isChecked: function (a) {
        return (a._conf.checked == true);
    },
    getExtraData: function (a) {
        return {type: "checkbox", checked: a._conf.checked};
    },
    optionClick: function (h, g, l) {
        var e = true;
        var c = (g.target || g.srcElement);
        while (e == true && c != null && c != h && c.className != null) {
            if (c.className.match(this.image_css_regexp) != null) {
                var a = [h._conf.value, !h._conf.checked];
                if (l.callEvent("onBeforeCheck", a) === true) {
                    this.setChecked(h, !this.isChecked(h));
                    l.callEvent("onCheck", a);
                }
                e = false;
                a = null;
            } else {
                c = c.parentNode;
            }
        }
        c = l = h = null;
        return e;
    },
    getTopImage: function () {
        return "";
    },
    topImageClick: function () {
        return true;
    }
};
dhtmlXComboExtend("checkbox", "option");
dhtmlXCombo.prototype.setChecked = function (a, c) {
    this.doWithItem(a, "setChecked", c);
};
dhtmlXCombo.prototype.getChecked = function () {
    var c = [];
    for (var e = 0; e < this.list.childNodes.length; e++) {
        if (this.isChecked(e)) {
            c.push(this._getOptionProp(this.list.childNodes[e]._optId, "value", ""));
        }
    }
    return c;
};
dhtmlXCombo.prototype.isChecked = function (a) {
    return this.doWithItem(a, "isChecked");
};


dhtmlXCombo.prototype.modes.image = {
    image: true,
    html: false,
    image_css: "dhxcombo_image",
    option_css: "dhxcombo_option_text dhxcombo_option_text_image",
    render: function (a, c) {
        a._conf = {value: c.value, css: ""};
        a.className = "dhxcombo_option";
        a.innerHTML = "<div class='" + this.image_css + "'></div><div class='" + this.option_css + "'>&nbsp;</div>";
        if (c.css != null) {
            a.lastChild.style.cssText += c.css;
            a._conf.css = c.css;
        }
        this.setText(a, c.text);
        this.setImage(a, c.img, c.img_dis, c.img_path, c.img_def, c.img_def_dis);
        return this;
    },
    update: function (a, c) {
        a._conf.value = c.value;
        a._conf.css = c.css;
        a.lastChild.style.cssText = c.css;
        this.setText(a, c.text);
        this.setImage(a, c.img, c.img_dis, c.img_path, c.img_def, c.img_def_dis);
    },
    setImage: function (e, a, h, l, g, c) {
        if (a != null && a.length > 0) {
            a = l + a;
        } else {
            if (g != null && g.length > 0) {
                a = l + g;
            } else {
                a = null;
            }
        }
        if (h != null && h.length > 0) {
            h = l + h;
        } else {
            if (c != null && c.length > 0) {
                h = l + c;
            } else {
                if (c == true) {
                    h = a;
                } else {
                    h = null;
                }
            }
        }
        e._conf.img = a;
        e._conf.img_dis = h;
        e.firstChild.style.backgroundImage = (a != null ? "url(" + a + ")" : "none");
    },
    getExtraData: function () {
        return {type: "image"};
    },
    getTopImage: function (g, e) {
        var c = (e ? "img" : "img_dis");
        if (g != null && g._conf[c] != null) {
            return "<div class='" + this.image_css + "' style='background-image:url(" + g._conf[c] + ");'></div>";
        }
        return "";
    }
};
dhtmlXComboExtend("image", "option");
dhtmlXCombo.prototype.setDefaultImage = function (a, c) {
    if (a != null) {
        this.conf.img_def = a;
    }
    if (c != null) {
        this.conf.img_def_dis = c;
    }
};
dhtmlXCombo.prototype.setImagePath = function (a) {
    this.conf.img_path = a;
};




// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXCombo/dhtmlXComboMethod.js